<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
  >
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :show="notification.show"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        @close="removeNotification(notification.id)"
      />
    </div>
  </div>
</template>

<script>
import { useNotifications } from '../composables/useNotifications';
import Notification from './Notification.vue';

export default {
  name: 'NotificationContainer',
  components: {
    Notification,
  },
  setup() {
    const { notifications, removeNotification } = useNotifications();

    return {
      notifications,
      removeNotification,
    };
  },
};
</script>
